"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BasketCreationOrigin=void 0;var i;(function(e){e.ProductDetailsView="Product Details View",e.StoreView="Store View"})(i||(exports.BasketCreationOrigin=i={}));
//# sourceMappingURL=BasketCreationOrigin.js.map
